<span [class.disabled]="item.disabled">{{item.text | translate}}</span>
